export const defaultViewSettings = {
    showAccounts: true,
    showPractices: true,
    showTotalInteractions: true,
    showUrgent: true,
    showRoutine: true,
    showAvgUrgentReadTime: true,
    showMedianUrgentReadTime: false,
    showAvgCallbackTime: true,
    showMedianCallbackTime: false,
    showAvgCallbackDuration: true,
    showMedianCallbackDuration: false,
    showCallbackCount: true,
    showVoicemails: true,
    showTransfers: true,
    showIsBackup: false,
    showIsForward: false,
    chartDataRange: "Daily",
    defaultDateRange: "7d",
    minimumCallDurationSeconds: 10,
    excludeHangupsAndDisconnects: true,
    showPracticesFilter: true,
    showScheduleNameFilter: true,
    showPriorityAndOriginatorGraphs: true,
    threshold5Minutes: 300,
    threshold15Minutes: 900,
    threshold30Minutes: 1800,
    selectedKPI: undefined,
    savedKPIs: [],
    restoreLastSessionOnStartup: false,
    version: "1.0.0",
};
export const VIEW_SETTINGS_KEY = "perfectserve-interactions-viewSettings";
//# sourceMappingURL=viewSettings.js.map